import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { bodyFontSize } from 'src/constants/stylesheet';

const useStyles = makeStyles(() =>
  createStyles({
    section: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap',

      [mediaQueries.Mobile]: {
        paddingLeft: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,
        paddingRight: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile / 2}px`,

        // paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,
        paddingRight: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet / 2}px`,

        // paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,
        paddingRight: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop / 2}px`,

        // paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,
        paddingRight: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop / 2}px`,

        // paddingBottom: spacing.Gutter.Desktop,
      },
      [mediaQueries.BigDesktop]: {
        paddingLeft: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,
        paddingRight: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop / 2}px`,

        // paddingBottom: spacing.Gutter.BigDesktop,
      },
    },
    sectionInner: {
      [mediaQueries.Mobile]: {
        width: `100%`,
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        width: `${2 / 3 * 100}%`,
        marginLeft: 'auto',
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        width: `${2 / 3 * 100}%`,
        marginLeft: 'auto',
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        width: `${2 / 3 * 100}%`,
        marginLeft: 'auto',
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,
      },
      [mediaQueries.BigDesktop]: {
        width: `${2 / 4 * 100}%`,
        marginLeft: 'auto',
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,
      }
    },
    overTitle: {
      ...stylesheet.MainTitle,
    },
    mainTitle: {
      ...stylesheet.MainTitle,
    },
    mainTitleMargin: {
      [mediaQueries.Mobile]: {
        marginTop: `${10 / bodyFontSize.Desktop}rem`,
      },
      [mediaQueries.Tablet]: {
        marginTop: `${10 / bodyFontSize.Tablet}rem`,
      },
      [mediaQueries.Laptop]: {
        marginTop: `${10 / bodyFontSize.Laptop}rem`,
      },
      [mediaQueries.Desktop]: {
        marginTop: `${10 / bodyFontSize.Desktop}rem`,
      },
      [mediaQueries.BigDesktop]: {
        marginTop: `${15 / bodyFontSize.BigDesktop}rem`,
      }
    },
    subTitle: {
      ...stylesheet.SubTitle,
    },
    subTitleMargin: {
      [mediaQueries.Mobile]: {
        marginTop: `${5 / bodyFontSize.Desktop}rem`,
      },
      [mediaQueries.Tablet]: {
        marginTop: `${5 / bodyFontSize.Tablet}rem`,
      },
      [mediaQueries.Laptop]: {
        marginTop: `${5 / bodyFontSize.Laptop}rem`,
      },
      [mediaQueries.Desktop]: {
        marginTop: `${5 / bodyFontSize.Desktop}rem`,
      },
      [mediaQueries.BigDesktop]: {
        marginTop: `${5 / bodyFontSize.BigDesktop}rem`,
      }
    },
    info: {
      // ...stylesheet.Introduction,
    },
    infoSize: {
      [mediaQueries.Mobile]: {
        width: '100%'
      },
      [mediaQueries.Tablet]: {
        maxWidth: spacing.panelTextMaxWidth.Small,
      },
      [mediaQueries.Laptop]: {
        maxWidth: spacing.panelTextMaxWidth.Small,
      },
      [mediaQueries.Desktop]: {
        maxWidth: spacing.panelTextMaxWidth.Small,
      },
      [mediaQueries.BigDesktop]: {
        maxWidth: spacing.panelTextMaxWidth.Big,
      }
    },
    notes: {},
  }));

export type IntroProps = {
  OverTitle?: string;
  Title?: string;
  Subtitle?: string;
  Info?: string;
  Notes?: string;
  ShowTitle?: boolean;
  type?: string;
};

type Props = IntroProps;

const Intro: FC<Props> = ({ OverTitle, Title, Subtitle, Info, Notes, ShowTitle, type }) => {
  const cls = useStyles();

  const isArtistPage = type && type === 'Artist';

  return (
    <section className={cls.section}>
      <div className={cls.sectionInner}>
        {OverTitle && <h2 className={cls.overTitle}>{OverTitle}</h2>}
        {Title && ShowTitle &&
          <h1 className={classNames(isArtistPage ? cls.mainTitle : cls.subTitle, cls.mainTitleMargin)}>{Title}</h1>
        }
        {Subtitle && <h3 className={cls.subTitleMargin}>{Subtitle}</h3>}
        {Info &&
          <div
            className={classNames(cls.info, cls.infoSize)}
            dangerouslySetInnerHTML={{ __html: Info }}
          />
        }
        {Notes && <div className={cls.notes}>{Notes}</div>}
      </div>
    </section>
  );
};

export default Intro;


// WEBPACK FOOTER //
// ./src/Components/Intro.tsx